<template>
  <div class="register container mt-5">
    <div class="logo"><router-link to="/"><img src="@/assets/images/storesafe-logo.png" width="100%" /></router-link></div>
    <h1 style="text-align: center;">{{ $t('register.heading') }}</h1>
    <form @submit.prevent="register">
      <div class="form-group">
        <label for="name">{{ $t('register.name_label') }} <span class="red">*</span></label>
        <input type="text" v-model="name" class="form-control" required />
      </div>
      <div class="form-group">
        <label for="company">{{ $t('register.company_label') }} <span class="red">*</span></label>
        <input type="text" v-model="company" class="form-control" required />
      </div>
      <div class="form-group">
        <label for="industry">{{ $t('register.industry_label') }} <span class="red">*</span></label>
        <select v-model="industry" class="form-control" required>
          <option value="" disabled>{{ $t('register.select_one') }}</option>
          <option value="Independent Restaurant">{{ $t('industry.independent_restaurant') }}</option>
          <option value="Restaurant Group">{{ $t('industry.restaurant_group') }}</option>
          <option value="Hotel">{{ $t('industry.hotel') }}</option>
          <option value="Catering">{{ $t('industry.catering') }}</option>
          <option value="Chain Restaurant">{{ $t('industry.chain_restaurant') }}</option>
          <option value="Supermarket">{{ $t('industry.supermarket') }}</option>
          <option value="Convenience Store">{{ $t('industry.convenience_store') }}</option>
          <option value="K-12 School">{{ $t('industry.k12_school') }}</option>
          <option value="College & University">{{ $t('industry.college_university') }}</option>
          <option value="Corrections">{{ $t('industry.corrections') }}</option>
          <option value="Military/Government">{{ $t('industry.military_government') }}</option>
          <option value="Business & Industry">{{ $t('industry.business_industry') }}</option>
          <option value="Cambro Rep">Cambro Rep</option>
        </select>
      </div>
      <div class="form-group">
        <label for="email">{{ $t('register.email_label') }} <span class="red">*</span></label>
        <input type="email" v-model="email" class="form-control" required />
      </div>
      <div class="form-group">
        <label for="password">{{ $t('register.password_label') }} <span class="red">*</span></label>
        <small class="form-text text-muted">{{ $t('register.password_hint') }}</small>
        <div class="password-input">
          <input :type="showPassword ? 'text' : 'password'" v-model="password" class="form-control" required />
          <i class="fas fa-eye" @click="showPassword = !showPassword" :class="{ 'fa-eye-slash': showPassword }"></i>
          <i v-if="password && confirmPassword && passwordsMatch" class="fas fa-check-circle text-success"></i>
        </div>
      </div>
      <div class="form-group">
        <label for="confirmPassword">{{ $t('register.confirm_password_label') }} <span class="red">*</span></label>
        <div class="password-input">
          <input :type="showConfirmPassword ? 'text' : 'password'" v-model="confirmPassword" class="form-control" required />
          <i class="fas fa-eye" @click="showConfirmPassword = !showConfirmPassword" :class="{ 'fa-eye-slash': showConfirmPassword }"></i>
          <i v-if="password && confirmPassword && passwordsMatch" class="fas fa-check-circle text-success"></i>
        </div>
      </div>

      <div class="form-group">
        <label>{{ $t('register.is_rep_question') }} <span class="red">*</span></label>
        <div>
          <input type="radio" id="repNo" v-model="isCambroRep" :value="false" class="rep-radio" checked>
          <label for="repNo" class="rep-label">{{ $t('ui.no') }}</label>
          <input type="radio" id="repYes" v-model="isCambroRep" :value="true" class="rep-radio">
          <label for="repYes" class="rep-label">{{ $t('ui.yes') }}</label>
        </div>
      </div>
      <div class="cleaner"></div>

      <p v-if="passwordError" class="text-danger">{{ passwordError }}</p>
      <button type="submit" class="btn-register" :disabled="!passwordsMatch">{{ $t('register.submit') }}</button>
      <p v-if="error" class="text-danger">{{ error }}</p>
    </form>
    <div style="text-align: center;width:100%;">
      {{ $t('register.have_account') }} &nbsp;
      <router-link v-if="!isLoggedIn" to="/login">{{ $t('register.login_link') }}</router-link>
    </div>
  </div>
  <!-- <div class="login" style="text-align: center;">
    
  </div> -->
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import authClient from '@/authClient'

export default {
  data() {
    return {
      name: '',
      company: '',
      industry: '',
      email: '',
      password: '',
      confirmPassword: '',
      isCambroRep: false,
      error: '',
      passwordError: '',
      showPassword: false,
      showConfirmPassword: false
    };
  },
  computed: {
    passwordsMatch() {
      return this.password === this.confirmPassword;
    }
  },
  watch: {
    password() {
      this.validatePasswords();
    },
    confirmPassword() {
      this.validatePasswords();
    }
  },
methods: {
   ...mapActions(['loginUser']),
   validatePassword(password) {
     const minLength = 8;
     const hasUpperCase = /[A-Z]/.test(password);
     const hasLowerCase = /[a-z]/.test(password);
     const hasNumbers = /\d/.test(password);
     const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

     return {
       isValid: password.length >= minLength && hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChar,
       errors: [
         password.length < minLength && this.$t('register.error_password_length'),
         !hasUpperCase && this.$t('register.error_password_uppercase'),
         !hasLowerCase && this.$t('register.error_password_lowercase'),
         !hasNumbers && this.$t('register.error_password_number'),
         !hasSpecialChar && this.$t('register.error_password_special')
       ].filter(Boolean)
     };
   },
   validatePasswords() {
     const validation = this.validatePassword(this.password);
     if (!validation.isValid) {
       this.passwordError = validation.errors[0];
       return;
     }
     if (this.password !== this.confirmPassword) {
       this.passwordError = this.$t('register.error_password_match');
     } else {
       this.passwordError = "";
     }
   },
   async register() {
     const validation = this.validatePassword(this.password);
     if (!validation.isValid) {
       this.error = validation.errors[0];
       return;
     }
     if (!this.passwordsMatch) {
       this.error = "Passwords do not match. Please try again.";
       return;
     }
     try {
       console.log('Registering user with data:', {
         email: this.email,
         company: this.company,
         isRep: this.isCambroRep
        });
       
       const response = await axios.post(`/api/users/register`, {
         name: this.name,
         company: this.company,
         industry: this.industry,
         email: this.email,
         password: this.password,
         isRep: this.isCambroRep  // Make sure we're sending this
       });
       
       // Store user data in Vuex
       this.$store.commit('auth/setUser', {
         ...response.data.user,
         isRep: this.isCambroRep
       });
       
       // Emit login success event with correct isRep value
       this.$emit('login-success', {
         ...response.data.user,
         isRep: this.isCambroRep
       });
       
       // Go directly to dashboard after registration
       this.$router.push('/dashboard');
       
     } catch (error) {
       if (error.response) {
         console.error('Error response:', error.response);
         this.error = error.response.data.error || error.response.statusText;
       } else if (error.request) {
         console.error('Error request:', error.request);
         this.error = 'No response received from server.';
       } else {
         console.error('Error message:', error.message);
         this.error = error.message;
       }
     }
   }
  },
};
</script>